var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.499 15.363a.61.61 0 001 0c3.691-5.349 4.376-5.897 4.376-7.863A4.875 4.875 0 0010 2.625 4.875 4.875 0 005.125 7.5c0 1.966.685 2.514 4.374 7.863zm.5-5.831A2.031 2.031 0 017.969 7.5 2.031 2.031 0 0110 5.469 2.031 2.031 0 0112.031 7.5 2.031 2.031 0 0110 9.531z"
  })));
}
export default SvgPin;